<div class="ui-g ui-fluid">
    <div class="ui-g-12" class="background">
        <div class="ui-g-12">
            <p class="subTitle">Asistencia dental</p>
            <h2 class="title">¿A qué tiene acceso y cuánto debe pagar?</h2>
        </div>
    </div>
    <div class="ui-g-12 p-grid">
        <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="ui-g-12">
                <div class="cardGray3" style="margin-bottom: 0;">
                <div class="p-col-12">
                    <h4 class="subTitle2">Asistencia gratuita</h4>
                    <p>A partir del primer día de vigencia</p>
                </div>
               <div class="p-col-12">
                 <h4 class="subTitle2">- Tratamiento de urgencia</h4>
                 <p class="paragraph">Urgencias - odontalgia - Rayos-X (peri apicales) o
                    radiovisiografía digital (retiro nervio)- sutura de heridas mucosa oral
                    - retiro de cuerpo extraño - tratamiento de alveolitis - drenaje absceso intraoral-
                    reinplatación dental post avulsión.</p>
               </div>
               <div class="p-col-12">
                <h4 class="subTitle2">- Emergencias protésicas</h4>
                <p>Reparación de prótesis en consultorio - rebase prótesis
                    - reparación diente acrílico (prótesis) - reposición diente
                    temporaal acrilico= re-cementanion temporaal coronas.
                <p>A partir del día 31 de vigencia.</p>
              </div>
              <div class="p-col-12">
                <h4 class="subTitle2">- Promoción y prevención </h4>
                <p>Examen clinico y diagnostico - fisioterapia oral radiografia
                    panorámica - rayos-X (Peri apicales) o radiovisiografía
                    digital - radiografía aleta de mordida (para diagnostico)
                    aplicación de flúor en gel - remoción de cálculos supragingi vales y profilaxis (cada 6 meses ).</p>
              </div>
              <div class="p-col-12">
                <h4 class="subTitle2">- Odontopediatría</h4>
                <p>Examen clinico y diagnostico - fisioterapia oral radiografia
                    panorámica - rayos-X (Peri apicales) o radiovisiografía
                    digital - radiografía aleta de mordida (para diagnostico)
                    aplicación de flúor en gel - remoción de cálculos supragingi vales y profilaxis (cada 6 meses ).</p>
              </div>
            </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="ui-g-12">
                <div class="cardGray3">
                    <div class="p-col-12">
                        <h4 class="subTitle2">Asistencia con participación del 20%</h4>
                        <p>A partir del dia 3l de vigencia</p>
                    </div>
                    <div class="p-col-12">
                        <h4 class="subTitle2">- Periodoncia</h4>
                        <p>Gingivectomía por sextante ( no incluye motivos
                            estéticos ) tunelización furca - cuña distal
                            operculectomía (capuchones pericoronarios ) drenaje
                            absceso periodontal - curetaje o campo cerrado (raspaje
                            y alisado radicular )- curetaje a campo abierto (raspaje alisado radicular )
                            cirugia mucogingival para cubrimiento de raíces cirugia mucogingival para manejo
                            de rebordes mantenimiento periodontal.</p>
                    </div>
                    <div class="p-col-12">
                        <h4 class="subTitle2">- Restauración</h4>
                        <p>Restauración en resina una a cuatro superficies
                            restauración en resina dora cuellos.</p>
                    </div>
                </div>
            </div>
            <div class="ui-g-12">
                <div class="cardGray2" style="margin-bottom: 0;">
                    <div class="p-col-12">
                        <h4 class="subTitle2">Asistencia con participación del 50%</h4>
                        <p>A partir del dia 31 de vigencia.
                            Endodoncia dientes anteriores, premolares o molares
                            permanentes ( tratamiento de nervio o canal ).
                            </p>
                    </div>
                    <div class="p-col-12">
                        <h4 class="subTitle2" style="margin-bottom: 0;">IMPORTANTE:</h4>
                        <ul>
                            <li>La asistencia no incluye gastos por sedación.</li>
                            <li>No se cubren medicamentos ambulatorios.</li>
                            <li>No aplica reembolso.</li>
                            <li>Aplica restricciones</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ui-g-12 p-grid">
        <div class="ui-g-1 ui-md-6 ui-lg-6"></div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
           <div class="ui-g-12">
                <div class="cardBlue ui-g-12">
                    <div class="ui-g-12 p-grid">
                        <div class="ui-g-12 ui-md-8 ui-lg-8">
                            <h3 class="important">Guarde la información de esta asistencia en su celular escaneando el siguiente código QR.</h3>
                        </div>
                        <div class="ui-g-12 ui-md-4 ui-lg-4">
                            <div class="center">
                                <img class="margin" src="../../assets/images/dental/QR.png" alt="" >
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>